export default "__VITE_ASSET__bf0c0b89__"